<template>
  <base-auth>
    <div>
    <h5>{{ passwordChangeMessage || $t('auth.title.recover_pass') }}</h5>
    </div>
    <div class="kt-login__form" id="before_code_verify">
      <form @submit.prevent="onSubmit" id="phone_number_form" class="kt-form">
        <vue-recaptcha
          v-if="captchaDriver === 'recaptcha'"
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          :sitekey="sitekey"
          :loadRecaptchaScript="true">
        </vue-recaptcha>

        <arcaptcha-vue
          v-if="captchaDriver === 'arcaptcha'"
          ref="arcaptchaForget"
          :site_key="arCaptchaKey"
          :invisible="true"
          :callback="onArcaptchaSuccess"
          :expired_callback="onArcaptchaExpired"
          :error_callback="onArcaptchaError"
        />

        <kt-form-control
          v-bind:placeholder="$t('auth.placeholder.short_phone')"
          name="phone"
          id="phone"
          v-model="phone"
        ></kt-form-control>
        <div class="kt-login__actions">
          <kt-button
            type="submit"
            id="phone_number_submit"
            variant="brand"
            class="btn-pill btn-elevate"
          >
            {{ $t('auth.btn.send_code') }}
          </kt-button>
        </div>
      </form>
      <verify-code v-model="code" :phone="phone" @resendCode="resendCode"/>
    </div>
    <div id="change_pass" class="kt-login__form disp-none">
      <reset-password :code="code" :phone="phone" @showMessage="handleMessage"/>
    </div>
  </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import { authService } from '@/common/api.service'
import { KTApp } from '@/plugins/core/app'
import $ from 'jquery'
import VueRecaptcha from 'vue-recaptcha'
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import ResetPassword from "@/views/auth/ResetPassword.vue";
import VerifyCode from "@/views/auth/VerifyCode.vue";
import ArcaptchaVue from 'arcaptcha-vue'

export default {
  data() {
    return {
      phone: '',
      code: '',
      time_counter: 60,
      login_event: null,
      recaptcha_verified: false,
      arcaptchaVerified: false,
      g_recaptcha_response: '',
      arcaptchaToken: '',
      sitekey: reCaptchaKeys,
      arCaptchaKey: arCaptchaKeys,
      captchaDriver: getCaptchaDriver,
      message: this.$route.query.message || '',
      passwordChangeMessage: sessionStorage.getItem('passwordChangeMessage') || ''
    }
  },
  components: {
    VerifyCode,
    ResetPassword,
    'base-auth': baseAuth,
    'vue-recaptcha': VueRecaptcha,
    ArcaptchaVue
  },

  beforeDestroy() {
    sessionStorage.removeItem('passwordChangeMessage')
  },

  methods: {
    onSubmit: function (e) {
      this.login_event = e;
      this.executeCaptcha();
    },

    executeCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.invisibleRecaptcha.execute();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
        this.$refs.arcaptchaForget.execute();
      } else {
        this.sendCode(this.login_event);
      }
    },

    // reCAPTCHA methods
    onVerify: function (response) {
      this.recaptcha_verified = true;
      this.g_recaptcha_response = response;
    
      if (this.login_event) {
        this.sendCode(this.login_event);
      } else {
        this.doResendCode();
      }
    },

    onExpired: function () {
      this.recaptcha_verified = false;
    },

    onArcaptchaSuccess(token) {
      this.arcaptchaToken = token;
      this.arcaptchaVerified = true;
    
      if (this.login_event) {
        this.sendCode(this.login_event);
      } else {
        this.doResendCode();
      }
    },

    onArcaptchaExpired() {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
    },

    onArcaptchaError(error) {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
      this.showMsg($('#phone_number_form'), 'danger', 'Captcha verification failed. Please try again.');
    },

    resetCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.invisibleRecaptcha && this.$refs.invisibleRecaptcha.reset();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.$refs.arcaptchaForget && this.$refs.arcaptchaForget.reset();
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
      }
    },

    isCaptchaVerified() {
      if (this.captchaDriver === 'recaptcha') {
        return this.recaptcha_verified;
      } else if (this.captchaDriver === 'arcaptcha') {
        return this.arcaptchaVerified && this.arcaptchaToken;
      }
      return true;
    },
    
    getCaptchaResponse() {
      if (this.captchaDriver === 'recaptcha') {
        return this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        return this.arcaptchaToken;
      }
      return '';
    },

    handleMessage({ type, message }) {
      let form = $('#change_pass_form')
      this.showMsg(form, type, message)
    },

    sendCode() {
      let btn = $('#phone_number_submit')
      let form = $('#phone_number_form')
      let code_form = $('#code_form')
      let resend_code_section = $('#resend_code_section')
      let phone = $('#phone')

      form.validate({
        ignore: ".ignore",
        rules: {
          phone: {
            required: true
          },
        }
      })

      if(!form.valid()) {
        return
      }

      if (!this.isCaptchaVerified()) {
        return;
      }

      KTApp.progress(btn)

      authService.sendForgetPassCode({
        phone: this.phone,
        ...(this.captchaDriver === 'recaptcha' && { 'g-recaptcha-response': this.g_recaptcha_response }),
        ...(this.captchaDriver === 'arcaptcha' && { 'g-recaptcha-response': this.arcaptchaToken })
      })
        .then(() => {
          btn.addClass('disp-none')
          code_form.removeClass('disp-none')
          resend_code_section.removeClass('disp-none')
          phone.attr("disabled", "disabled")
          this.resendCounter(60)
        })
        .catch((error) => {
          if (error.response.data.data)
            form.validate().showErrors(error.response.data.data)
          else
            this.showMsg(form, 'danger', error.response.data.message)
          this.recaptcha_verified = false
          this.arcaptchaVerified = false
          this.resetCaptcha()
        })
        .finally(() => {
          this.resetCaptcha()
          KTApp.unprogress(btn)
        })
    },

    doResendCode() {
      let form = $('#phone_number_form')
      let btn = $('#resend_btn')
      let code_field = $('#code')
      let resend_counter_div = $('#resend_counter_div')
        
      code_field.val('*****')
        
      authService.resendCode({
        phone: this.phone,
        ...(this.captchaDriver === 'recaptcha' && { 'g-recaptcha-response': this.g_recaptcha_response }),
        ...(this.captchaDriver === 'arcaptcha' && { 'g-recaptcha-response': this.arcaptchaToken })
      })
        .then((response) => {
          btn.addClass('disp-none')
          resend_counter_div.removeClass('disp-none')
          this.resendCounter(120)
          this.showMsg(form, 'success', response.data.message)
        })
        .catch((error) => {
          this.showMsg(form, 'danger', error.response.data.message)
        })
        .finally(() => {
          code_field.val('')
          this.resetCaptcha()
        })
    },

    resendCounter(timeout) {
      var count = timeout

      let internal = setInterval(function () {
        let t = count - 1
        count -= 1
        $("#timer_span").empty().append(t);

        if (count < 1) {
          $('#resend_counter_div').addClass('disp-none')
          $('#resend_btn').removeClass('disp-none')
          clearInterval(internal);
        }
      }, 1000)
    },

    resendCode() {
      this.login_event = null;
      this.executeCaptcha();
    },

    showMsg(form, type, message) {
      form.find('.alert').remove();
      
      let alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
      let alertHtml = `
        <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
          <div class="alert-text">${message}</div>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      `;
      
      form.prepend(alertHtml);
      
      setTimeout(() => {
        form.find('.alert').fadeOut(300, function() {
          $(this).remove();
        });
      }, 8000);
    }
  }
}
</script>

<style>
.disp-none {
  display: none !important;
}
.make-hover:hover {
  color: #5d78ff!important;
}
</style>